module.exports = __webpack_public_path__ + "assets/img/lg-Deutsche-Fachwerkstrasse.8384d643.jpg";